module.exports = __webpack_public_path__ + "static/img/ccrc.4715df3b.png";